import React from 'react';
import { Form, Formik } from 'formik';
import { connectWithStore } from '@react/Common/connectWithStore';
import { ChangeUserEmail } from '@react/Pages/UsersPage/CreateUserSidebar/ChangeUserEmail';
import { getUserPermissionsState } from '@redux/ducks/userPermissions/userPermissions';
import { AppAccessLink } from './AppAccessLink';
import { ChangeUserRole } from './ChangeUserRole';
import { ToggleFeatures } from './ToggleFeatures';

export const UserPermissionFormComponent = ({
  initialValues,
  isSubmitting,
  isNewUser,
  isSubmitEnable,
  onSubmit,
  onCancel,
}) => {
  const isSaveDisabled = isValid => {
    const isEmailFieldValid = !isNewUser || isValid;
    return !isSubmitEnable || !isEmailFieldValid;
  };

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({ isValid }) => (
        <Form className="flex-one flex-box-column">
          <div className="flex-one flex-box-column">
            <div className="panel-section">
              <ChangeUserEmail />
              <ChangeUserRole />
              <ToggleFeatures />
            </div>
            <AppAccessLink />
          </div>
          <div className="panel-footer flex-auto">
            <div className="flex-box-row">
              <a onClick={onCancel} className="btn flex-one">
                {t('action.cancel')}
              </a>
              <button
                disabled={isSaveDisabled(isValid) || isSubmitting}
                type="submit"
                className="btn btn-main flex-one"
              >
                {isNewUser ? t('action.create') : t('action.save')}
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = state => {
  const { user, canApplyUserPermissions, canApplyAppPermissions, isSubmitting } = getUserPermissionsState(state);
  const canApply = canApplyUserPermissions || canApplyAppPermissions;

  return {
    initialValues: {
      email: user.email,
    },
    isSubmitting,
    isNewUser: !user?.id,
    isSubmitEnable: user?.id ? canApply : Boolean(user.email),
  };
};

export const UserPermissionForm = connectWithStore(mapStateToProps)(UserPermissionFormComponent);
